import React from 'react';
import MarketList from './MarketList';

export default function BTCMarket({ intent = 'sell' }) {
  return <MarketList intent={intent} coin="BTC" />;
}
